"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function Mb(props) {
  var _a = props || {},
      type = _a.type,
      configuration = _a.configuration;

  var _b = configuration || {},
      _c = _b.list,
      list = _c === void 0 ? [] : _c,
      _d = _b.bulletinData,
      bulletinData = _d === void 0 ? {} : _d;

  var _e = bulletinData || {},
      title = _e.title,
      desc = _e.desc;

  var newList = list;

  if ((list === null || list === void 0 ? void 0 : list.length) > 3) {
    newList = list.slice(0, 3);
  }

  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'SME_mb'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('SME_mb-container', {
      'SME_mb-container--default': !type || type && !['cyan'].includes(type),
      'SME_mb-container--cyan': type && ['cyan'].includes(type)
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'SME_head-card'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'SME_head-card-container'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'span-title'
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'head-span-description'
  }, desc))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'SME_head-foot'
  }, newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: 'SME_list-card'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-title'
    }, item === null || item === void 0 ? void 0 : item.desc), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('blue-title-mo', {
        'span-description--cyan': type && ['cyan'].includes(type)
      })
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-txt-mo'
    }, item === null || item === void 0 ? void 0 : item.txt), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-description'
    }, item === null || item === void 0 ? void 0 : item.num)));
  }))));
}

var _default = Mb;
exports["default"] = _default;